import React from 'react';
import './network-status.scss';
import { FeasibilityStatusScheama, FeasibilityStatus } from './network-constant';

type Props = {
  src?: string;
  status: 'FEASIBLE' | 'MANUAL_INTERVENTION_REQUIRED' | 'EXPIRED' | 'PENDING';
  address?: string;
};

export const NetworkStatus: React.FC<Props> = ({ status = 'FEASIBLE', address }) => {
  const getFeasibilityStatus = (status: string) => {
    if (FeasibilityStatus[status]) {
      return FeasibilityStatus[status];
    }
    return FeasibilityStatus['MANUAL_INTERVENTION_REQUIRED'];
  };
  return (
    <>
      <div className="network_status">
        <div className="inside_content">
          <div className="icon">
            <img src={getFeasibilityStatus(status)?.src} alt="Success" />
          </div>
          <div className="content_info">
            <div className="title">{getFeasibilityStatus(status)?.title}</div>
            <div className="address">{address}</div>
          </div>
        </div>
      </div>
    </>
  );
};
